module.exports = __webpack_public_path__ + "static/media/grsmixed.fec4d1e8.png";